import styled from "styled-components/macro";

export const Title = styled.div`
  ${({ theme }) => `
padding-left: ${theme.space[2]}px;
font-weight: bold;
font-size: ${theme.fontSizes.gamma}px;
`}
`;
